// @atlas/contracts — a `activity-log` modul Zod-sémái
//
// A fájl CSAK sémákat tart (érték-szintű Zod-objektumok + a belőlük inferált típusok) — a ROUTE-ok
// egyetlen `atlasContract` objektum-literálban maradnak (`src/index.ts`), mert a ts-rest
// kontextus-inferenciája a lapos bővítésre érzékeny. A sémák mozgatása ezt NEM érinti: sima értékek.
import { z } from 'zod';
/** Eseménynapló-lekérdezés: szabad-szöveg (művelet/entitás), szereplő, dátum-tartomány, cursor-lapozás. */
export const ActivityLogQuerySchema = z.object({
    /** Szabad-szöveg a műveletre (action) és az érintett entitásra (resourceRef). */
    q: z.string().optional(),
    /** Szereplő-szűrő: név / e-mail részlet. */
    actor: z.string().optional(),
    /** Alsó időhatár — ISO dátum (YYYY-MM-DD) vagy dátum-idő. */
    from: z.string().optional(),
    /** Felső időhatár — ISO dátum (YYYY-MM-DD) vagy dátum-idő. */
    to: z.string().optional(),
    /** Kategória-szűrő: vessző-elválasztott lista (data,admin,auth_security,auth_session,security,system);
     *  üres → a default feed-nézet (data+admin+auth_security). */
    category: z.string().optional(),
    /** App-szűrő a KÖZPONTI (multi-app) admin-konzolhoz: egy app kulcsa → CSAK annak eseményei; üres → MINDEN app
     *  (a UI defaultja `atlas`). A szerver ezt az Odin `?app=` audit-szűrőjére továbbítja (kereszt-app olvasónál). */
    app: z.string().optional(),
    limit: z.coerce.number().int().positive().max(200).optional(),
    cursor: z.string().optional(),
});
/**
 * LISTA-EXPORT AUDIT — a felület bejelenti, hogy egy exportot LEFUTTATOTT (ki, mit, milyen szűrővel, hány sor).
 *
 * MIÉRT KELL: az export a szűrt találatot FÁJLBA írja, vagyis PII-tömeg hagyja el a rendszert — ez a
 * legexfil-relevánsabb művelet a felületen, és eddig NEM hagyott nyomot (a lista-lapozás csak
 * „olvasás"-ként látszott a platform naplójában). Az Odin `POST /v1/audit/events`-én keresztül `export.list`
 * action-ként kerül az audit-naplóba, `security` kategóriában.
 *
 * A `filters` SZÁNDÉKOSAN lapos, string-értékű map: a napló nem adat-tár, csak azt kell megmutatnia, MIT
 * vitt el a felhasználó. A BFF a kulcsokat whitelisteli, az Odin pedig skalárra + méretre szűkít.
 */
export const ExportAuditBodySchema = z.object({
    /** A lista-oldal gépi azonosítója (a fájlnév-slug): `clients` · `accounts` · `contacts` · … */
    module: z.string().min(1).max(64),
    format: z.enum(['xlsx', 'csv', 'json']),
    /** Hány sor került a fájlba (a csonkolás UTÁN — a valóban kivitt darabszám). */
    rowCount: z.number().int().nonnegative(),
    /** Elérte-e a plafont (a fájl a szűrt halmaz ELEJE) — a naplóban is látszania kell. */
    truncated: z.boolean(),
    /** Az AKTÍV szűrők olvasható pillanatképe (kulcs → érték); a BFF whitelisteli. */
    filters: z.record(z.string(), z.string()).optional(),
});
//# sourceMappingURL=schemas.js.map